export class MsgTemplate {
  msgTemplateId: number;
  name: string;
  senderName: string;
  senderEmail: string;
  subject: string;
  emailHtml: string;
  emailText: string;
  senderMobileNum: string;
  senderCountryCode: string;
  mobileText: string;
  msgAudience: number;
  status: number;
  communicationMediumCode: number;
}
